
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.041.135L4 4H1c-.553 0-1 .49-1 1.032v5.95C0 11.524.447 12 1 12h3l4.062 3.904S9 16.467 9 14.842V1.109C9-.535 8.041.135 8.041.135zM10.498 4.058c-.273-.034-.498.193-.498.469v1c0 .276.228.494.495.562.862.223 1.505 1.01 1.505 1.938s-.643 1.716-1.505 1.938c-.267.068-.495.286-.495.562v1c0 .276.225.503.498.47a4 4 0 000-7.939z"}}),_c('path',{attrs:{"d":"M10 .527v1c0 .276.225.498.499.521C13.576 2.302 16 4.885 16 8.027s-2.424 5.726-5.501 5.979a.535.535 0 00-.499.521v1c0 .276.225.502.5.484 4.187-.258 7.5-3.732 7.5-7.984S14.687.3 10.5.043a.476.476 0 00-.5.484z"}})])
          )
        }
      }
    